// Bundle selection — 2 preselected
let selected = 2;
selectBundle(2);

function selectBundle(n) {
  selected = n;
  document.querySelectorAll('.bundle-card').forEach(c => c.classList.remove('selected'));
  var _c = document.getElementById('card' + n); if (_c) _c.classList.add('selected');
}

// Datos de los packs (precios y variantes reales de Shopify)
var BBW_VARIANTS = { 1: '53408346669419', 2: '53408346702187', 3: '53408346734955' };
var BBW_PRICES   = { 1: 19990, 2: 29990, 3: 36990 };
var BBW_LABELS   = { 1: '1 unidad · 1 mes', 2: '2 unidades · 2 meses', 3: '3 unidades · 3 meses' };
var BBW_FREE_SHIP = 24990;
function bbwFmt(n) { return '$' + n.toLocaleString('es-CL'); }

// Botón de compra — agrega la variante real al carrito de Shopify y abre el carrito lateral
function handleBuy() {
  var sel = selected;
  var variantId = BBW_VARIANTS[sel] || BBW_VARIANTS[2];
  var btn = document.getElementById('buyBtn');
  if (btn) { btn.textContent = 'Agregando...'; btn.classList.add('added'); }
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
    })
    .then(function () {
      if (btn) { btn.textContent = 'Quiero mi BeBodywise'; btn.classList.remove('added'); }
      renderCartDrawer(sel);
      openCartDrawer();
    })
    .catch(function () {
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1&return_to=/checkout';
    });
}

// ── CARRITO LATERAL (confirmación antes del checkout) ──
function renderCartDrawer(sel) {
  var price = BBW_PRICES[sel] || BBW_PRICES[2];
  var img = window.BBW_IMG || '';
  var items = document.getElementById('cdItems');
  if (items) {
    items.innerHTML =
      '<div class="cd-item">' +
        '<img src="' + img + '" alt="BeBodywise Serum" class="cd-item-img" />' +
        '<div class="cd-item-info">' +
          '<div class="cd-item-name">BeBodywise Hair Density Serum</div>' +
          '<div class="cd-item-sub">' + (BBW_LABELS[sel] || '') + '</div>' +
        '</div>' +
        '<div class="cd-item-price">' + bbwFmt(price) + '</div>' +
      '</div>';
  }
  var total = document.getElementById('cdTotal');
  if (total) total.textContent = bbwFmt(price);

  // Barra de envío gratis
  var ship = document.getElementById('cdShip');
  var fill = document.getElementById('cdShipFill');
  if (ship && fill) {
    var pct = Math.min(100, Math.round((price / BBW_FREE_SHIP) * 100));
    fill.style.width = pct + '%';
    var gap = BBW_FREE_SHIP - price;
    ship.querySelector('.cd-ship-msg').innerHTML = gap > 0
      ? 'Te faltan <strong>' + bbwFmt(gap) + '</strong> para envío gratis'
      : '🎉 <strong>¡Tienes envío gratis!</strong>';
  }
}
function openCartDrawer() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cdOverlay').classList.add('show');
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cdOverlay').classList.remove('show');
  document.body.style.overflow = '';
}
function goCheckout() { window.location.href = '/checkout'; }

// DRAWER MENU
function toggleMenu() {
  const open = document.getElementById('drawer').classList.toggle('open');
  document.getElementById('drawerOverlay').classList.toggle('show', open);
  document.getElementById('hamburger').classList.toggle('active', open);
  document.body.style.overflow = open ? 'hidden' : '';
}
function closeMenu() {
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('drawerOverlay').classList.remove('show');
  document.getElementById('hamburger').classList.remove('active');
  document.body.style.overflow = '';
}

// CANCEL SUBSCRIPTION MODAL
function openCancelSub() {
  closeMenu();
  document.getElementById('cancelForm').style.display = '';
  document.getElementById('cancelDone').style.display = 'none';
  document.getElementById('cancelModal').classList.add('show');
}
function closeCancel() { document.getElementById('cancelModal').classList.remove('show'); }
function submitCancel(e) {
  e.preventDefault();
  document.getElementById('cancelForm').style.display = 'none';
  document.getElementById('cancelDone').style.display = 'block';
}

// TERMS ACCORDION
function toggleAcc(btn) {
  const item = btn.closest('.acc-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.acc-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// Sticky bar
const stickyBar = document.getElementById('stickyBar');
window.addEventListener('scroll', () => {
  stickyBar.classList.toggle('show', window.scrollY > 500);
}, { passive: true });

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); window.scrollTo({ top: target.offsetTop - 70, behavior: 'smooth' }); }
  });
});

// COUNTDOWN — expires in ~10 hours from page load
(function() {
  const end = new Date().getTime() + (10 * 60 * 60 + 23 * 60 + 47) * 1000;
  function tick() {
    const diff = end - new Date().getTime();
    if (diff <= 0) return;
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    document.getElementById('cdHours').textContent = String(h).padStart(2, '0');
    document.getElementById('cdMins').textContent = String(m).padStart(2, '0');
    document.getElementById('cdSecs').textContent = String(s).padStart(2, '0');
  }
  tick();
  setInterval(tick, 1000);
})();

// SOCIAL PROOF TOASTS
const toastEl = document.getElementById('toast');
const toasts = [
  { name: 'Camila S.', city: 'Santiago', pack: '2 unidades', time: '3 min' },
  { name: 'Diego M.', city: 'Viña del Mar', pack: '3 unidades', time: '7 min' },
  { name: 'Valentina R.', city: 'Concepción', pack: '2 unidades', time: '12 min' },
  { name: 'Andrés L.', city: 'Temuco', pack: '1 unidad', time: '15 min' },
  { name: 'Paula G.', city: 'Antofagasta', pack: '3 unidades', time: '2 min' },
  { name: 'Fernanda O.', city: 'La Serena', pack: '2 unidades', time: '5 min' },
];
let ti = 0;

function showToast() {
  const t = toasts[ti % toasts.length];
  toastEl.innerHTML = `<strong>${t.name}</strong> de ${t.city} compró <strong>${t.pack}</strong> hace ${t.time}.`;
  toastEl.classList.add('show');
  setTimeout(() => toastEl.classList.remove('show'), 4000);
  ti++;
}

// First toast after 6s, then every 18s
setTimeout(() => {
  showToast();
  setInterval(showToast, 18000);
}, 6000);

// SCROLL REVEAL — fade-up sections on scroll
(function() {
  const targets = document.querySelectorAll('.benefit, .how-step, .ing-item, .ugc-card, .before-after-feature, .bundle-card, .test-card, .terms-section, .acc-item');
  targets.forEach(t => t.classList.add('reveal'));
  if (!('IntersectionObserver' in window)) {
    targets.forEach(t => t.classList.add('in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 });
  targets.forEach(t => io.observe(t));
})();

// Close drawer / modal with Escape
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closeMenu(); closeCancel(); }
});
